<script lang="ts">
  import { state_questionImageSearch } from '../store/state';

  function removeImage(indexToRemove: number) {
    const attachment = $state_questionImageSearch[indexToRemove];

    const updatedImages = $state_questionImageSearch.filter(
      (_, i) => i !== indexToRemove
    );
    $state_questionImageSearch = updatedImages;

    URL.revokeObjectURL(attachment.previewUrl);
  }
</script>

{#each $state_questionImageSearch as image, i}
  <div
    class="cs-image-attachment-display"
    class:cs-image-attachment-uploading={image.status === 'uploading'}
    class:cs-image-attachment-error={image.status === 'error'}
  >
    <img src={image.previewUrl} alt={`Uploaded image ${i + 1}`} />
    {#if image.status === 'uploading'}
      <div class="cs-image-attachment-status">...</div>
    {:else if image.status === 'error'}
      <div class="cs-image-attachment-status">!</div>
    {/if}
    <div class="cs-image-attachment-overlay">
      <button on:click={() => removeImage(i)}> x </button>
    </div>
  </div>
{/each}

<style lang="scss">
  @use './../../scss/components/image-attachment-display';
</style>
